import { LayoutModule } from '../../../../layout/modules';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Box } from '@mui/material';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    MOTIVE,
    MOTIVE_DETAIL,
    MOTIVE_EDIT,
    MOTIVE_NEW,
} from '../../../../../routes/paths';

import { useMotiveDetail } from './hook';
import { MotiveData } from './data';
import { MotiveRegisterHistory } from './registerHistory';
import { MotiveHistorical } from '../historical';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';

export const MotiveDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const {
        motive,
        loading,
        motiveHistorical,
        showHistorical,
        setShowHistorical,
    } = useMotiveDetail();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle motivo"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={encodeURIComponent(motive?.name || '')}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: MOTIVE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: MOTIVE,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: MOTIVE_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: MOTIVE_DETAIL,
                        }}
                        extraParam={motive?.active ?? ''}
                        buttonLog={{
                            show: true,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <MotiveHistorical
                            historical={motiveHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Proceso"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PeopleAltIcon sx={{ color: 'primary.main' }} />}
                >
                    <MotiveData motive={motive} loading={loading} />
                </LayoutModule>
            </LayoutModule>
            <MotiveRegisterHistory motive={motive} />
        </>
    );
};
